import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, #161D25 0%, #070C12 100%);

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px;
`;

export const Title = styled.div`
  width: 450px;
  color: #fff;
  font-family: inherit;
  font-size: 26px;
  line-height: 40px;
  text-align: center;
  line-height: 1.1;
`;

export const Divider = styled.div`
  height: 20px;
`;
